<template>
  <div class="tbl-container" v-if="stack">
    <table>
      <tr class="t-header text-blue-dark text-[18px]">
        <th>RefHash</th>
        <th>Type</th>
        <th>Block</th>
        <th>Timestamp</th>
        <th>From</th>
        <th>To</th>
        <th>Status</th>
      </tr>
      <tr v-for="item in txs" :key="item.uniqueId" style="border-top: 1px solid #2699fb;">
        <td class="max-w-[200px] min-w-[200px]">
          <div class="align-middle text-blue-light flex items-start">
            <span class="cursor-pointer" @click="item.toggled=!item.toggled">
              <i class="fa fa-minus text-[14px] text-blue-light" v-if="item.toggled"></i>
              <i class="fa fa-plus text-[14px] text-blue-light" v-else></i>
            </span>

            <span class="align-middle text-blue-light break-all ml-[10px]">
              <div class="flex flex-wrap">
                <router-link v-if="item && item.refHash" class="cursor-pointer align-middle text-blue-light break-all"
                  :to="{ name: 'transaction', params: { chainNumber: item.chainNumber || $route.params.chainNumber || $route.params.chain, txRefhash: item.refHash }}">
                  {{ !item.toggled ? getShortenedText(item.refHash) : item.refHash }}
                </router-link>
                <CopyIcon v-if="item.toggled" :isActive="checkIfIsEqual(item.refHash, item.uniqueId)"
                  @click="copy(item.refHash, item.uniqueId)" title="Copy hash"
                  class="min-w-[16px] h-[19px] inline-block cursor-pointer align-text-top ml-[10px]" />
              </div>
            </span>
          </div>
        </td>
        <td class="text-blue-dark text-[18px] max-w-[100px] min-w-[100px] Stack align-middle">
          <div class="flex items-start">
            Stack
          </div>
        </td>
        <td class="align-middle max-w-[150px] min-w-[150px]">
          <div class="flex items-start">
            <router-link v-if="item && item.blockNumber" class="text-blue-dark cursor-pointer ml-[10px]"
              :to="{ name: 'block', params: { chainNumber: item.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: item.blockNumber }}">
              {{ item.blockNumber }}
            </router-link>
          </div>
        </td>

        <td class="max-w-[200px] min-w-[200px] align-middle">
          {{ getTxCreatedAt(item.createdAt) }}
        </td>
        <td class="max-w-[200px] min-w-[200px] align-middle">
          <router-link :to="{ name: 'account', params: { chainNumber: item.chainNumber || $route.params.chainNumber || $route.params.chain, address: item.pubKeyHash } }"
            class="align-middle text-blue-dark break-all !text-inter-medium">
            <div class="inline">
              {{ !item.toggled ? getShortenedText(item.pubKeyHash) : item.pubKeyHash }}
            </div>
          </router-link>
          <CopyIcon v-if="item.toggled" :isActive="checkIfIsEqual(item.pubKeyHash, item.uniqueId + 'from')"
            @click="copy(item.pubKeyHash, item.uniqueId + 'from')" title="Copy hash"
            class="min-w-[16px] h-[19px] inline-block cursor-pointer align-text-top ml-[10px]" />
        </td>
        <td class="max-w-[200px] min-w-[200px] align-middle">
          <router-link :to="{ name: 'account', params: { chainNumber: item.chainNumber || $route.params.chainNumber || $route.params.chain, address: item.acctNumReceive } }"
            class="align-middle text-blue-dark break-all !text-inter-medium">
            <div class="inline">
              {{ !item.toggled ? getShortenedText(item.acctNumReceive) : item.acctNumReceive }}
            </div>
          </router-link>
          <CopyIcon v-if="item.toggled" :isActive="checkIfIsEqual(item.acctNumReceive, item.uniqueId + 'to')"
            @click="copy(item.acctNumReceive, item.uniqueId + 'to')" title="Copy hash"
            class="min-w-[16px] h-[19px] inline-block cursor-pointer align-text-top ml-[10px]" />
        </td>
        <td class="text-blue-dark text-[18px] max-w-[100px] min-w-[100px]">
          <img v-if="item.status==='valid'" src="/images/icons/status-valid-icon.svg" class="w-[24px] h-[24px]" />
          <i v-else class="w-[24px] h-[24px] rounded-[50%] fa fa-times-circle text-[28px]" />
        </td>
      </tr>
      <template v-if="txs.length < maxTableRows">
        <tr v-for="index in (maxTableRows - txs.length)" :key="index" class="border-t border-blue-row h-[63px]">
          <template v-for="i in colsCount" :key="i">
            <td></td>
          </template>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import string from '@/helpers/string';
import { maxTableRows } from '@/utils/pagination';
import CopyIcon from '@/components/svg/CopyIcon';

import { generateUniqueNumber } from '@/helpers/numbers';

import moment from 'moment';

export default {
  name: 'StackTransactionsTbl',
  emits: ['copied'],
  components: {
    CopyIcon,
  },
  props: {
    stack: {
      type: [Object, null],
      required: true,
    },
    transactions: {
      type: Array,
      required: true,
      default: () => [],
    },
    copied: {
      type: String,
      default: '',
    },
  },
  watch: {
    transactions(val) {
      if (val.length) {
        this.txs = val.map(tx => ({
          ...tx,
          uniqueId: generateUniqueNumber()
        }));
      }
    }
  },
  data() {
    return {
      maxTableRows,
      colsCount: 7,
      txs: [],
    };
  },
  mounted() {
    this.txs = this.transactions.map(tx => ({
      ...tx,
      uniqueId: generateUniqueNumber()
    }));
  },
  methods: {
    getShortenedText(str) {
      if (!str) {
        return '';
      }
      return string.getShortenHash(str)
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.$emit('copied', hash + uId);
    },
    getTxCreatedAt(createdAt) {
      if (!createdAt) {
        return '';
      }
      return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
  }
};
</script>
